import React, { useEffect, useState } from 'react';
import PrintText from './PrintText';
import { Field } from 'redux-form/immutable';
import { renderField, convertToNumber } from './_FORM_FIELDS';
import { Button } from 'reactstrap';
import RenderIcon from '../commons/RenderIcon';

const PositiveNumber = (props) => {
    const { classProperty, type, validations, value, isReadOne, ...rest } = props;

      const layoutItem = props.layoutItem;

      const showAsButtons = layoutItem && layoutItem.itemProperties && layoutItem.itemProperties.positiveNumberConfig && layoutItem.itemProperties.positiveNumberConfig.showAsButtons;
    
    return (
        <div>
            {
                isReadOne ?
                    <PrintText {...props} /> : showAsButtons ? (<Field
                        name={classProperty}
                        component={AdditionButtons}
                        disabled={props.disableLayoutItem}
                        value={value}
                        {...rest}
                    />) : 
                    <Field
                        name={classProperty}
                        component={renderField}
                        disabled={props.disableLayoutItem}
                        type="number"
                        validate={props.disableLayoutItem ? [] : validations}
                        value={value}
                        fieldType={type}
                        onBlur={() => {
                            const cEventKeys = window.cEvents && Object.keys(window.cEvents);
                            Array.isArray(cEventKeys) &&       cEventKeys.map(k => {
                                k.startsWith(classProperty) &&
                                window.cEvents[k](props.formValues);
                            });
                        }}
                        {...rest}
                        normalize={convertToNumber}
                    />
            }
        </div>
    );
}

const AdditionButtons = (props) => {
    const [value, setValue] = useState(props.input.value ? props.input.value: 0);

    return <div className='d-flex justify-content-center button-container'>
        <Button className="mr-2" color={"warning"} disabled={value<1} onClick={()=> {
            if(value > 0) {
                props.input.onChange(value-1);
                setValue(value-1)
            }
        }}><RenderIcon config={{cssClass: 'fa-minus'}} /></Button>
        <span className="mr-2 d-flex align-items-center">{value}</span>
        <Button color={"warning"} onClick={()=> {
            props.input.onChange(value+1);
            setValue(value+1)
        }}><RenderIcon config={{cssClass: 'fa-plus'}} /></Button>
    </div>
}

export default PositiveNumber;